import React, { useState, useEffect, useRef } from "react";
import HeroSection from "../components/HeroSection";
import Navbar from "../components/Navbar";
import Services from "../components/Services";
import Form from "../components/Form";
import Loader from "../components/Loader";

const Home = () => {
  const serviceRef = useRef(null);
  const aboutRef = useRef(null);
  const getStartedRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <div
          className="d-flex flex-column slide-up"
          style={{
            minHeight: "100vh",
          }}
        >
          <Navbar
            serviceRef={serviceRef}
            aboutRef={aboutRef}
            getStartedRef={getStartedRef}
          />

          <div className="hero-section">
            <HeroSection />
          </div>

          <div
            className={`other-sections ${
              scrolled ? "scrolled" : ""
            }`}
            style={{
              flex: 1,
            }}
          >
            <Services
              ref={serviceRef}
              aboutRef={aboutRef}
              getStartedRef={getStartedRef}
            />

            <div className="form-section">
              <Form getStartedRef={getStartedRef} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;